import React, { useEffect, useState } from 'react';
import { Box, Container, IconButton, Typography } from '../imports/muiImport';

import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../hooks/contexts/AuthContext';
import { userTokenSave } from '../apiCalls/functions';
import { actionNotifier } from '../components/tostify';
import OTPComponent from './otp/OTPComponent';
import Timer from '../pages/LOGIN_SIGNUP/OTP/Timer';
import { registerUser, resendOTP, verifyEmail } from '../apiCalls/urls/urlFunction';
import Signup from './authPages/Signup';

const SignupPage = () => {
  const [signupFormStep, setSignupFormStep] = useState({
    isShowUserPersonalDetailsForm: true,
    isShowOTPForm: false,
  });

  const [isResendAvailable, setIsResendAvailable] = useState(false);
  const [otpFormLoading, setOtpFormLoading] = useState(false);
  const [isResetOtp, setIsResetOtp] = useState(false);
  const [isUserAuthentic, setIsUserAuthentic] = useState({});
  const [otpFormTimer, setOtpFormTimer] = useState(15);
  const [noOfUserOTPSend, setNoOfUserOTPSend] = useState(0);
  const navigate = useNavigate();

  const handleOtpVerify = async (email, otp) => {
    setOtpFormLoading(true);
    const loginResponse = await verifyEmail({ email, otp });

    if (loginResponse?.status) {
      actionNotifier.success(loginResponse?.message, {
        position: 'top-left',
        autoClose: 2000,
      });

      if (isUserAuthentic?.isLoginForm) {
        setTimeout(() => {
          navigate('/', { replace: true });
          setOtpFormLoading(false);
        }, 300);
      } else {
        setTimeout(() => {
          navigate('/login', { replace: true });
          setOtpFormLoading(false);
          setIsResetOtp(true);
        }, 300);
      }
    } else {
      actionNotifier.error(loginResponse?.message, {
        position: 'top-left',
        autoClose: 2000,
      });
      setOtpFormLoading(false);
      setIsResetOtp(true);
    }
  };

  const handleOtpResend = async () => {
    if (isResendAvailable) {
      const response = await resendOTP({
        email: isUserAuthentic?.email,
      });

      if (response?.status) {
        setNoOfUserOTPSend((prevState) => prevState + 1);
        setOtpFormTimer(() => 15);

        actionNotifier.info('OTP has been resent', { position: 'top-left', autoClose: 1000 });
      }
    } else {
      actionNotifier.warning(`Please wait for the timer to resend OTP`, {
        position: 'top-left',
        autoClose: 1000,
      });
    }
  };

  const handleUserForm = (key) => {
    setSignupFormStep((prevState) => {
      switch (key) {
        case 'USERREGISTERFORMFILLSUCCESSFUL':
          return {
            ...prevState,
            isShowUserPersonalDetailsForm: false,
            isShowOTPForm: true,
          };
        default:
          return {
            isShowUserPersonalDetailsForm: true,
            isShowOTPForm: false,
          };
      }
    });
  };

  const timerEnd = () => {
    if (noOfUserOTPSend <= 2) {
      setIsResendAvailable(() => true);
      setOtpFormTimer(() => null);
      setOtpFormLoading(false);
    } else {
      setOtpFormLoading(false);
      setIsResetOtp(true);
      setIsResendAvailable(() => false);
      window.location.reload();
    }
  };

  useEffect(() => {
    console.log('isUserAuthentic : ', isUserAuthentic);
  }, []);

  return (
    <>
      {signupFormStep?.isShowUserPersonalDetailsForm && (
        <Signup setIsUserAuthentic={setIsUserAuthentic} handleUserForm={handleUserForm} />
      )}

      {signupFormStep?.isShowOTPForm && (
        <>
          <OTPComponent
            email={isUserAuthentic?.email}
            purpose="Sign up OTP"
            loading={otpFormLoading}
            isResendAvailable={isResendAvailable}
            onVerifyOtp={handleOtpVerify}
            onResendOtp={handleOtpResend}
            isResetOtp={isResetOtp}
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Timer initialTime={otpFormTimer} timeEnd={timerEnd} timerStyle={{}} />
          </Box>
        </>
      )}
    </>
  );
};

export default SignupPage;
